import { Injectable } from '@angular/core';

interface AuthToken {
  accessToken: string;
  tokenType: 'Bearer';
}

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private authToken: AuthToken | undefined;

  saveAuthenticationInfo(authToken: AuthToken): void {
    this.authToken = authToken;
    localStorage.setItem('authSession', JSON.stringify(this.authToken));
  }

  getAuthorizationHeader(): string | undefined {
    if (this.authToken !== undefined) {
      return `Bearer ${this.authToken.accessToken}`;
    }
    const stored = localStorage.getItem('authSession');
    if (!stored) return undefined;
    const parsed = JSON.parse(stored) as AuthToken;
    this.saveAuthenticationInfo(parsed);
    return `Bearer ${parsed.accessToken}`;
  }

  getAuthTokenOnly(): string | undefined {
    this.getAuthorizationHeader();
    return this.authToken?.accessToken;
  }

  clearSession(): void {
    this.authToken = undefined;
    localStorage.clear();
    sessionStorage.clear();
  }
}
